import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6">
      <div className="text-center max-w-xl">
        <div className="text-[10px] uppercase tracking-[0.28em] text-[#71717a] mb-4">
          404
        </div>
        <h1 className="font-heading text-4xl md:text-5xl text-white leading-tight">
          This page has moved on.
        </h1>
        <p className="text-[#a1a1aa] mt-6">
          The page you are looking for is not here. Try one of these instead.
        </p>
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link to="/" className="btn-gold">
            Home
          </Link>
          <Link to="/packages" className="btn-outline">
            Packages
          </Link>
          <Link to="/contact" className="btn-outline">
            Contact
          </Link>
        </div>
      </div>
    </div>
  );
}
